import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { salariesSurveyRoute } from '#/modules/salaries/routing/salaries.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { CompensationSurveyPageLoadable } from './CompensationSurveyPageLoadable';

export const handle = {
  variant: 'base',
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof salariesSurveyRoute>,
) {
  await CompensationSurveyPageLoadable.load();
}

export default function CompensationSurveyHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <CompensationSurveyPageLoadable />;
}
